import DefenseManagePane from "./DefenseManagePane";
import DefenseManagePaneCustomItem from "./DefenseManagePaneCustomItem";

export default DefenseManagePane;
export { DefenseManagePane, DefenseManagePaneCustomItem };
